import { render, staticRenderFns } from "./PemdaTransactionBulkContent.vue?vue&type=template&id=75f10a18&lang=pug"
import script from "./PemdaTransactionBulkContent.vue?vue&type=script&lang=js"
export * from "./PemdaTransactionBulkContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports